<template>
  <!-- Meet Our Team Section -->
  <div class="mt-10 sm:mt-20">
    <div class="mb-12 text-center">
      <h2 class="mb-4 text-3xl font-bold text-ternary-dark dark:text-primary-light sm:text-4xl">
        Meet Our Team
      </h2>
      <p class="text-lg text-gray-600 dark:text-gray-400">
        Talented professionals working together to deliver exceptional results
      </p>
    </div>

    <!-- Team Grid -->
    <div class="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3">
      <ProfileCard
        v-for="profile in teamProfiles"
        :key="profile.name"
        :profile="profile"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from '#imports'
import { PhClipboard, PhCode, PhPlus, PhUsers } from '@phosphor-icons/vue'
import ProfileCard from '~/components/About/ProfileCard.vue'

const teamProfiles = ref([
  {
    name: 'Artur',
    title: 'Lead Developer',
    description: 'Full-stack developer with 20+ years of experience. Specializes in Vue.js, Laravel, and modern web technologies.',
    image: '/images/arthur.jpg',
    link: '/about/vedmant',
    skills: ['Vue.js', 'Laravel', 'Node.js', 'Full-Stack'],
    roleIcon: PhCode,
    isPlaceholder: false,
  },
  {
    name: 'Dasha',
    title: 'Project Manager',
    description: 'Strategic communications expert with proven track record in international business development and project management.',
    image: '/images/dasha.jpg',
    link: '/about/dasha',
    skills: ['Project Management', 'Strategic Communications', 'International Business', 'Leadership'],
    roleIcon: PhClipboard,
    isPlaceholder: false,
  },
  {
    name: 'Growing Team',
    title: 'Future Team Member',
    description: 'We\'re always looking for talented individuals to join our growing team.',
    skills: ['TBD', 'TBD', 'TBD'],
    roleIcon: PhPlus,
    placeholderIcon: PhUsers,
    button: 'Contact Us',
    buttonLink: '/contact',
    isPlaceholder: true,
  },
])
</script>
